/**
 * Money utilities. All monetary values are integers in minor units
 * (e.g. kobo for NGN, cents for USD) to avoid floating point errors.
 */
export const SUPPORTED_CURRENCIES = ["NGN", "USD", "GBP", "EUR"];
/** Minor-unit exponent per currency. */
const EXPONENTS = {
    NGN: 2,
    USD: 2,
    GBP: 2,
    EUR: 2,
};
export function isCurrency(value) {
    return SUPPORTED_CURRENCIES.includes(value);
}
/** Convert a major-unit amount (e.g. 1500.50) to minor units (150050). */
export function toMinorUnits(amount, currency) {
    const factor = 10 ** EXPONENTS[currency];
    return Math.round(amount * factor);
}
/** Convert minor units to a major-unit number. */
export function toMajorUnits(amountMinor, currency) {
    const factor = 10 ** EXPONENTS[currency];
    return Number(amountMinor) / factor;
}
/** Format minor units as a human readable string, e.g. "₦1,500.50". */
export function formatMoney(amountMinor, currency, locale = "en-NG") {
    const value = toMajorUnits(amountMinor, currency);
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: EXPONENTS[currency],
        maximumFractionDigits: EXPONENTS[currency],
    }).format(value);
}
/** Sum minor-unit amounts safely. */
export function sumMinor(amounts) {
    return amounts.reduce((acc, a) => acc + BigInt(a), 0n);
}
/** Compute a percentage fee in minor units, rounded to nearest integer. */
export function percentageFee(amountMinor, percent) {
    return Math.round((Number(amountMinor) * percent) / 100);
}
//# sourceMappingURL=money.js.map